import React, {useState} from 'react';
import styles from './../../Assets/CSS/ProfileSidebar.module.css';
import profileImage from './../../Assets/Images/profile.svg';
import contactImage from './../../Assets/Images/contactus.svg';
import suggestionImage from './../../Assets/Images/suggestion.svg';
import videoImage from './../../Assets/Images/trainingVideos.svg';
import helpImage from './../../Assets/Images/help.svg';
import listingImage from './../../Assets/Images/payout.svg';
import listingEnquiryImage from './../../Assets/Images/report.svg';
import paymentImage from './../../Assets/Images/wallet.svg';
import adsImage from './../../Assets/Images/AdsRAnk.svg'; 
import { useNavigate } from 'react-router-dom'; 

function Sidebar() {
   const [isCollapsed, setIsCollapsed] = useState(false);
       const navigate = useNavigate();
       const handleClick = (page) => {
           navigate(`/client/${page}`);
       }
       const toggleCollapse = () => {
           setIsCollapsed(!isCollapsed);
       }   
    return (
        <div className={`${styles.sidebar} ${isCollapsed ? 'new-sidebar-res' : ''}`}>
            <button
                id='side-nav-collapse-btn'
                className={isCollapsed ? 'new-side-nav-collapse-btn' : ''}
                onClick={toggleCollapse}
            >
                <svg width="16" height="16" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.25" y="1.25" width="93.5" height="93.5" rx="46.75" fill="#E3F4FD"></rect>
                    <rect x="1.25" y="1.25" width="93.5" height="93.5" rx="46.75" stroke="#0473A8" strokeWidth="2.5"></rect>
                    <path d="M30.4219 73H48C52.0384 73 55.3242 69.7142 55.3242 65.6758V30.3242C55.3242 26.2858 52.0384 23 48 23H30.4219C29.6122 23 28.957 23.6552 28.957 24.4648C28.957 25.2745 29.6122 25.9297 30.4219 25.9297H48C50.4232 25.9297 52.3945 27.901 52.3945 30.3242V65.6758C52.3945 68.099 50.4232 70.0703 48 70.0703H30.4219C29.6122 70.0703 28.957 70.7255 28.957 71.5352C28.957 72.3448 29.6122 73 30.4219 73Z" fill="#0473A8"></path>
                    <path d="M28.957 65.5781C28.957 66.3878 29.6122 67.043 30.4219 67.043H48C48.8097 67.043 49.4648 66.3878 49.4648 65.5781V59.7188C49.4648 58.9091 48.8097 58.2539 48 58.2539H30.4219C29.6122 58.2539 28.957 58.9091 28.957 59.7188V65.5781ZM28.957 50.9297C28.957 51.7394 29.6122 52.3945 30.4219 52.3945H48C48.8097 52.3945 49.4648 51.7394 49.4648 50.9297V45.0703C49.4648 44.2606 48.8097 43.6055 48 43.6055H30.4219C29.6122 43.6055 28.957 44.2606 28.957 45.0703V50.9297ZM30.4219 37.7461H48C48.8097 37.7461 49.4648 37.0909 49.4648 36.2812V30.4219C49.4648 29.6122 48.8097 28.957 48 28.957H30.4219C29.6122 28.957 28.957 29.6122 28.957 30.4219V36.2812C28.957 37.0909 29.6122 37.7461 30.4219 37.7461Z" fill="#0473A8"></path>
                </svg>
                <svg id="sbalx" width="16" height="16" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M75.3612 48.0001C75.3612 49.7207 74.7043 51.441 73.3932 52.7527L32.115 94.0305C29.4892 96.6563 25.2319 96.6563 22.6071 94.0305C19.9824 91.4058 19.9824 87.1493 22.6071 84.5233L59.1324 48.0001L22.6084 11.4768C19.9836 8.85096 19.9836 4.59494 22.6084 1.9704C25.2331 -0.656682 29.4904 -0.656682 32.1162 1.9704L73.3945 43.2476C74.7058 44.56 75.3612 46.2803 75.3612 48.0001Z" fill="#0473A8"></path>
                </svg>
            </button>
            <div className={styles.sidebarMenu}>
                <div className={styles.menuItem} onClick={() => handleClick('profile')}> 
                    <div className={styles.menuItemLeft}>
                        <img src={profileImage} className={styles.icon} />
                    </div> 
                    <div className={styles.menuItemName}>Profile</div>
                </div> 
                <div className={styles.menuItem} onClick={() => handleClick('contact-us')}>
                    <div className={styles.menuItemLeft}> 
                        <img src={contactImage} className={styles.icon} />
                    </div> 
                    <div className={styles.menuItemName}>Contact Us</div>
                </div>
                <div className={styles.menuItem} onClick={() => handleClick('market-feedback')}>
                    <div className={styles.menuItemLeft}>  
                        <img src={suggestionImage} className={styles.icon} />
                    </div> 
                    <div className={styles.menuItemName}>Market Feedback</div>
                </div>  
                <div className={styles.menuItem} onClick={() => handleClick('video')}>
                    <div className={styles.menuItemLeft}>
                        <img src={videoImage} className={styles.icon} />
                    </div> 
                    <div className={styles.menuItemName}>Video</div>
                </div> 
                <div className={styles.menuItem} onClick={() => handleClick('help')}>
                    <div className={styles.menuItemLeft}> 
                        <img src={helpImage} className={styles.icon} />
                    </div>  
                    <div className={styles.menuItemName}>Help</div>
                </div>
                <div className={styles.menuItem} onClick={() => handleClick('listing')}>
                    <div className={styles.menuItemLeft}> 
                        <img src={listingImage} className={styles.icon} />
                    </div>  
                    <div className={styles.menuItemName}>Business Listing</div>
                </div>  
                <div className={styles.menuItem} onClick={() => handleClick('listing-enquiry')}>
                    <div className={styles.menuItemLeft}> 
                        <img src={listingEnquiryImage} className={styles.icon} />
                    </div>  
                    <div className={styles.menuItemName}>Listing Enquiry</div>
                </div>
                <div className={styles.menuItem} onClick={() => handleClick('ads')}>
                    <div className={styles.menuItemLeft}> 
                        <img src={adsImage} className={styles.icon} />
                    </div>   
                    <div className={styles.menuItemName}>Ads Posting</div>
                </div>   
                <div className={styles.menuItem} onClick={() => handleClick('payment')}>
                    <div className={styles.menuItemLeft}> 
                        <img src={paymentImage} className={styles.icon} />
                    </div>   
                    <div className={styles.menuItemName}>Payment</div>
                </div>      
                <div className={styles.menuItem} onClick={() => handleClick('video-post')}>
                    <div className={styles.menuItemLeft}>  
                        <img src={videoImage} className={styles.icon} />
                    </div>     
                    <div className={styles.menuItemName}>Video Post</div>
                </div>           
            </div> 
        </div>
    );
}

export default Sidebar;   